<template>
  <div class="page_container">
    <div class="operationBtn">
        <el-button type="primary" icon="el-icon-top" class="backBtn" @click="goback()">课程目录</el-button>
        <!-- <el-button type="primary" icon="el-icon-refresh" class="refreshBtn">刷新</el-button> -->
    </div>
    <div class="operationrefreshBtn">
        <!-- <el-button type="primary" icon="el-icon-top" class="backBtn" @click="goback()">课程目录</el-button> -->
        <el-button type="primary" icon="el-icon-refresh" class="refreshBtn" @click="refreshPage()">刷新</el-button>
    </div>
    <div v-if="this.showCourseFlag" class="pageContent">
      <iframe :src="this.coursePageUr" id="page" scrolling="no" frameborder="1"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      v-loading.fullscreen.lock="true"></iframe>
    </div>
    <div v-else>
      <h2 style="padding-top:60px;">您<span style="color:red;"> 暂无权限 </span>查看该课程，请在【我的课程】中选择其他课程！</h2>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      queryInfo: {
        course_id: this.$route.query.course_id,
        lesson_id: this.$route.query.lesson_id,
        token: ''
      },
      coursePageUr: '',
      loading: false,
      showCourseFlag: true
    }
  },
  created () {
    this.queryInfo.token = window.sessionStorage.getItem('token')
    this.goToCourse()
    console.log('111-this.coursePageUr: ', this.coursePageUr)
  },
  mounted () {
    function changeMapIframe () {
      const map = document.getElementById('page')
      const deviceWidth = document.body.clientWidth
      const deviceHight = document.body.clientHeight
      map.style.width = (Number(deviceWidth) - 60) + 'px'
      map.style.height = (Number(deviceHight) - 140) + 'px'
    }
    changeMapIframe()
    window.onresize = function () {
      changeMapIframe()
    }
  },
  methods: {
    async goToCourse () {
      this.loading = true
      const { data: res } = await this.$http.get('app/courseurl/', { params: this.queryInfo })
      console.log('goToCourse res:', res[0].ret)
      if (res[0].ret === 2001) {
        this.showCourseFlag = false
      }
      // 跳转到课程页面
      // window.location.href = res[1].url
      this.coursePageUr = res[1].url
      console.log('goToCourse-', this.coursePageUr)
      console.log('showCourseFlag-', this.showCourseFlag)
      this.loading = false
    },
    goback () {
      this.$router.back()
    },
    refreshPage () {
      location.reload()
      this.$router.go(0)
    }
  }
}
</script>

<style lang="less" scoped>
.page_container{
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  // align-items: center;
}
.pageContent{
  width: 100%;
  height: 100%;
}
.operationBtn{
  display: flex;
  justify-content: space-between;
  text-align: center;
  // position: relative;
  .backBtn{
    position: fixed;
    left: 20px;
    z-index: 9999;
  }
}
.operationrefreshBtn{
  display: flex;
  justify-content: space-between;
  text-align: center;
  // position: relative;
  .refreshBtn{
    position: fixed;
    right: 20px;
    z-index: 9999;
  }
}
// #page{
//   position: absolute;
//   width: 100%;
//   height: 100%;
// }
</style>
